import { Component } from '@angular/core';
import { AuthService } from 'src/services';
import { NavigationService } from 'src/services/navigation.service';

@Component({
  selector: 'app-ocean-rate-methodology',
  templateUrl: './ocean-rate-methodology.component.html',
  styleUrl: './ocean-rate-methodology.component.scss'
})
export class OceanRateMethodologyComponent 
{
 constructor(private navigationService: NavigationService, private authService: AuthService) 
 { 

 }
  
 goToContractedWithin(type) {
    this.navigationService.setActiveTerm(type);
  }
 
  printPage() {
    window.print();
  }

  copyFullPageText() 
  {
    const textToCopy = document.body.innerText;

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.authService.showToast("info","All text on the page has been copied!");
    }).catch(err => {
      console.error("Failed to copy text: ", err);
    });
  }
}
